import React from 'react';

import CommonTooltip from '../../../../components/common-tooltip/CommonTooltip';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';

import scss from './ErrorTooltip.module.scss';

function ErrorTooltip({ error }) {
  if (!error) {
    return null;
  }

  return (
    <CommonTooltip title={error}>
      <div className={scss.errorTooltip}>
        <Icon icon={ICONS.Info} disableCommonColors className={scss.errorIcon} />
      </div>
    </CommonTooltip>
  );
}

export default ErrorTooltip;
